import React, { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';

const MemoryMatchGame = () => {
  const { isDark } = useTheme();
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [solved, setSolved] = useState([]);
  const [moves, setMoves] = useState(0);

  const symbols = ['🐱', '🐶', '🐰', '🐻', '🐵', '🐦'];

  const initializeGame = () => {
    const gameCards = [...symbols, ...symbols]
      .sort(() => Math.random() - 0.5)
      .map((symbol, index) => ({ id: index, symbol }));
    
    setCards(gameCards);
    setFlipped([]);
    setSolved([]);
    setMoves(0);
  };

  const handleCardClick = (id) => {
    if (flipped.length === 2 || solved.includes(id) || flipped.includes(id)) return;

    const newFlipped = [...flipped, id];
    setFlipped(newFlipped);

    if (newFlipped.length === 2) {
      setMoves(moves + 1);
      const [first, second] = newFlipped;
      
      if (cards[first].symbol === cards[second].symbol) {
        setSolved([...solved, first, second]);
      }

      setTimeout(() => setFlipped([]), 1000);
    }
  };

  useEffect(() => {
    initializeGame();
  }, []);

  // Theme Token Styles
  const titleClr   = isDark ? 'text-white' : 'text-gray-800';
  const labelClr   = isDark ? 'text-slate-400' : 'text-gray-600';
  const scoreClr   = isDark ? 'text-blue-400' : 'text-blue-600';
  
  // Card Styles
  const cardFlippedBg = isDark ? 'bg-blue-900/60 border-blue-500' : 'bg-blue-200 border-[#1E293B]';
  const cardDefaultBg = isDark ? 'bg-[#111C2C] hover:bg-[#1E3A5F] border-[#1E3A5F]' : 'bg-gray-200 hover:bg-gray-300 border-[#1E293B]';

  return (
    <div className="max-w-md mx-auto">
      <h3 className={`text-xl md:text-2xl font-bold text-center mb-6 pixel-font ${titleClr}`}>
        🧠 MEMORY MATCH
      </h3>
      
      <div className="flex justify-between items-center mb-6 px-2">
        <div className="text-center">
          <span className={`text-xs block ${labelClr}`}>MOVES</span>
          <span className={`text-xl font-bold ${scoreClr}`}>{moves}</span>
        </div>
        <div className="text-center">
          <span className={`text-xs block ${labelClr}`}>PAIRS FOUND</span>
          <span className={`text-xl font-bold ${scoreClr}`}>{solved.length / 2} / {symbols.length}</span>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-3 mb-6">
        {cards.map((card) => {
          const isOpen = flipped.includes(card.id) || solved.includes(card.id);
          return (
            <div
              key={card.id}
              className={`pixel-border h-16 md:h-20 flex items-center justify-center cursor-pointer text-2xl md:text-3xl transition-colors ${
                isOpen ? cardFlippedBg : cardDefaultBg
              }`}
              onClick={() => handleCardClick(card.id)}
            >
              {isOpen ? card.symbol : '?'}
            </div>
          );
        })}
      </div>

      <div className="flex justify-center">
        <button 
          className="pixel-button bg-blue-600 text-white px-6 py-2.5 hover:bg-blue-700 text-xs md:text-sm font-bold pixel-font"
          onClick={initializeGame}
        >
          RESTART
        </button>
      </div>
    </div>
  );
};

export default MemoryMatchGame;